import { ResponseChallenge } from '@app/models';

export type ChallengeCategorie = 'level'|'flash'|'mission'|'history';
export type ChallengeType = 'publication'|'review'|'event'|'external'|'demonstration'|'sale';

export class Challenge {
    ID: string;
    category: ChallengeCategorie;
    type: ChallengeType;
    level: string;
    title: string;
    description: string;
    hashtags: Array<string>;
    link: string;
    buttonLink: string;
    mediaLink: string;
    descriptionLink: string;
    commentEnabled: boolean;
    commentLabel: string;
    checkboxEnabled: boolean;
    checkboxLabel: string;
    responseType: Array<string>;
    responseTextRegex: string;
    responseTextError: string;
    optionalsMediasEnabled: boolean;
    optionalsMediasType: Array<string>;
    optionalsMediasMax: number;
    isSocialsEnabled: boolean;
    ambassadorsStatus: Array<string>;
    products: Array<string>;
    levels: Array<number>;
    isEnabled: boolean;
    startDate: string|null;
    endDate: string|null;
    response: ResponseChallenge;
    incentive: number;
    devise: string;
    points: number;
    externalTarget: any|null;
    target?: number;
    done?: number;
}

export class ChallengesLevel {
    name: string;
    earningsDisplay: 'show'|'hide';
    challenges: Array<Challenge> = [];
}

export class Challenges {
    levels: Array<ChallengesLevel> = [];
    missions: Array<Challenge> = [];
    flash: Array<Challenge> = [];
    history: Array<Challenge> = [];
}
